<template>
  <label class="flex gap-2 items-center cursor-pointer">
    <slot name="start" class="shrink-0" />
    <slot />
    <slot name="end" class="shrink-0 self-end" />
  </label>
</template>
